exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{scroll-behavior:smooth}main{display:grid;grid-template-columns:auto 1fr;position:sticky}main>.menu{position:sticky;top:0;height:100vh;z-index:100}@media screen and (max-width:750px){main{display:flex;flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74d77a03","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/Layout.vue
// module id = 129
// module chunks = 0